export default "__VITE_ASSET__6ef00e44__"